import { render, staticRenderFns } from "./simpleDialog.vue?vue&type=template&id=5e7e6966&"
import script from "./simpleDialog.vue?vue&type=script&lang=js&"
export * from "./simpleDialog.vue?vue&type=script&lang=js&"
import style0 from "./simpleDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "simpleDialog.vue"
export default component.exports